

import { ResponsivePie } from '@nivo/pie';

export default ResponsivePie;